import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/UserSlice";
import adminReducer from "./reducers/AdminSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    admin: adminReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
